import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=23c341c0&scoped=true&"
import script from "./template1.vue?vue&type=script&lang=ts&"
export * from "./template1.vue?vue&type=script&lang=ts&"
import style0 from "./template1.vue?vue&type=style&index=0&id=23c341c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c341c0",
  null
  
)

export default component.exports